import React, { useContext } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FlexView from 'react-flexview/lib'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import ClearIcon from '@material-ui/icons/Clear'
import DoneIcon from '@material-ui/icons/Done'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel'

export const WhatsCoveredSummarySection = () => {
  const insuranceContext = useContext(InsurancePurchaseContextStore)

  if (!FirebaseService.getBoolean(FirebaseConfigKey.WHATS_COVERED_AVAILABLE)) {
    return null
  }

  const covered = [
    { title: 'Aviation Liability', covered: true },
    { title: 'Property damage', covered: true },
    { title: 'Bodily injury', covered: true },
    { title: 'Privacy claims', covered: true },
  ]
  if (
    insuranceContext.selectedOption.billingPeriod !=
      InsuranceBillingPeriod.MONTH ||
    FirebaseService.getBoolean(
      FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_MONTHLY
    )
  ) {
    covered.push({
      title: 'Damage to the drone body',
      covered:
        insuranceContext.drones.length > 0 ||
        insuranceContext.selectedOption.dronePremium > 0,
    })
  }

  return (
    <Accordion elevation={0} className="summary-expansion transparent">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <FlexView className="space-between full-width">
          <div className="text-small gray">What's covered?</div>
          <div className="text-small gray">Read more</div>
        </FlexView>
      </AccordionSummary>
      <AccordionDetails>
        <ul>
          {covered.map((item, index) => (
            <FlexView
              vAlignContent={'center'}
              key={index}
              className="text-tiny margin-top-small black">
              {item.covered ? (
                <DoneIcon fontSize="small" className="margin-right-6 green" />
              ) : (
                <ClearIcon fontSize="small" className="margin-right-6 red" />
              )}{' '}
              {item.title}
            </FlexView>
          ))}
        </ul>
      </AccordionDetails>
    </Accordion>
  )
}
